
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-gray-50 dark:bg-gray-900 pt-12 pb-8">
      <div className="container-custom">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4">
              <span className="text-2xl font-bold text-fembot-pink">Fembot</span>
            </Link>
            <p className="text-gray-600 dark:text-gray-400 max-w-md">
              Fembot is a powerful Discord bot designed to enhance your server experience with moderation, AI capabilities, and more.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4 dark:text-white">Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-600 dark:text-gray-400 hover:text-fembot-pink dark:hover:text-fembot-pink transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/donate" className="text-gray-600 dark:text-gray-400 hover:text-fembot-pink dark:hover:text-fembot-pink transition-colors">
                  Donate
                </Link>
              </li>
              <li>
                <Link to="/features" className="text-gray-600 dark:text-gray-400 hover:text-fembot-pink dark:hover:text-fembot-pink transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/premium" className="text-gray-600 dark:text-gray-400 hover:text-fembot-pink dark:hover:text-fembot-pink transition-colors">
                  Premium
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-600 dark:text-gray-400 hover:text-fembot-pink dark:hover:text-fembot-pink transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-gray-600 dark:text-gray-400 hover:text-fembot-pink dark:hover:text-fembot-pink transition-colors">
                  Support
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 dark:border-gray-800 mt-10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-600 dark:text-gray-400 text-center">
              © {currentYear} Fembot. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/terms" className="text-gray-600 dark:text-gray-400 hover:text-fembot-pink dark:hover:text-fembot-pink transition-colors text-sm">
                Terms of Service
              </Link>
              <Link to="/privacy" className="text-gray-600 dark:text-gray-400 hover:text-fembot-pink dark:hover:text-fembot-pink transition-colors text-sm">
                Privacy Policy
              </Link>
              <Link to="/careers" className="text-gray-600 dark:text-gray-400 hover:text-fembot-pink dark:hover:text-fembot-pink transition-colors text-sm">
                Careers
              </Link>
              <Link to="/imprint" className="text-gray-600 dark:text-gray-400 hover:text-fembot-pink dark:hover:text-fembot-pink transition-colors text-sm">
                Imprint
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
